// ModalCrearEntidad.jsx
import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  InputAdornment,
} from "@mui/material";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600, // Aumentado el ancho para que se parezca a un formulario
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const ModalCrearEntidad = ({ open, handleClose, onCreateEntidad }) => {
  // Estados para cada campo del formulario
  const [descripcion, setDescripcion] = useState("");
  const [apellido, setApellido] = useState("");
  const [dniCuitCuil, setDniCuitCuil] = useState("");
  const [telefono, setTelefono] = useState("");
  const [email, setEmail] = useState("");
  const [direccion, setDireccion] = useState("");
  const [localidad, setLocalidad] = useState("");
  const [provincia, setProvincia] = useState("");
  const [tipoEntidad, setTipoEntidad] = useState(""); // 1 para cliente, 2 para proveedor
  // DATOS BANCARIOS
  const [nombreBanco, setNombreBanco] = useState("");
  const [numeroCuenta, setNumeroCuenta] = useState("");
  const [cbuCvuCuenta, setCbuCvuCuenta] = useState("");
  const [aliasCuenta, setAliasCuenta] = useState("");

  const handleSubmit = () => {
    // Se crea un objeto con los datos del formulario
    const nuevaEntidad = {
      descripcion,
      apellido,
      dniCuitCuil,
      telefono,
      email,
      direccion,
      localidad,
      provincia,
      tipoEntidad, // 1 o 2 según la selección
      // DATOS BANCARIOS
      nombreBanco,
      numeroCuenta,
      cbuCvuCuenta,
      aliasCuenta,
    };

    // Llamada a la función que envía los datos a la API o al estado global
    if (onCreateEntidad) {
      onCreateEntidad(nuevaEntidad);
    }

    // Se resetean los campos del formulario (opcional)
    setDescripcion("");
    setApellido("");
    setDniCuitCuil("");
    setTelefono("");
    setEmail("");
    setDireccion("");
    setLocalidad("");
    setProvincia("");
    setTipoEntidad("");
    // DATOS BANCARIOS
    setNombreBanco("");
    setNumeroCuenta("");
    setCbuCvuCuenta("");
    setAliasCuenta("");

    // Cerrar el modal
    handleClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        <Typography variant="h6" component="h2" gutterBottom>
          Crear nueva entidad proveedor
        </Typography>
        <Grid container spacing={2}>
          {/* Sección: Información Básica */}
          <Grid item xs={12}>
            <Typography variant="subtitle1">Información Básica</Typography>
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Nombre"
              fullWidth
              value={descripcion}
              onChange={(e) => setDescripcion(e.target.value)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Apellido"
              fullWidth
              value={apellido}
              onChange={(e) => setApellido(e.target.value)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="DNI / CUIT / CUIL"
              fullWidth
              value={dniCuitCuil}
              onChange={(e) => setDniCuitCuil(e.target.value)}
            />
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              {/* *HARDCODED* */}
              <InputLabel id="tipo-entidad-label">Tipo de Entidad</InputLabel>
              <Select
                labelId="tipo-entidad-label"
                label="Tipo de Entidad"
                value={tipoEntidad}
                onChange={(e) => setTipoEntidad(e.target.value)}
              >
                <MenuItem value={1}>Cliente</MenuItem>
                <MenuItem value={2}>Proveedor</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {/* Sección: Datos de Contacto */}
          <Grid item xs={12}>
            <Typography variant="subtitle1">Datos de Contacto</Typography>
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Teléfono"
              fullWidth
              value={telefono}
              onChange={(e) => setTelefono(e.target.value)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Email"
              fullWidth
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Grid>

          {/* Sección: Ubicación */}
          <Grid item xs={12}>
            <Typography variant="subtitle1">Ubicación</Typography>
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Dirección"
              fullWidth
              value={direccion}
              onChange={(e) => setDireccion(e.target.value)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Localidad"
              fullWidth
              value={localidad}
              onChange={(e) => setLocalidad(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Provincia"
              fullWidth
              value={provincia}
              onChange={(e) => setProvincia(e.target.value)}
            />
          </Grid>

          {/* Sección: Datos Bancarios */}
          <Grid item xs={12}>
            <Typography variant="subtitle1">Datos Bancarios</Typography>
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Nombre del Banco"
              fullWidth
              value={nombreBanco}
              onChange={(e) => setNombreBanco(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AccountBalanceIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Número de Cuenta"
              fullWidth
              value={numeroCuenta}
              onChange={(e) => setNumeroCuenta(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AccountBalanceIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="CBU / CVU"
              fullWidth
              value={cbuCvuCuenta}
              onChange={(e) => setCbuCvuCuenta(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AccountBalanceIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Alias"
              fullWidth
              value={aliasCuenta}
              onChange={(e) => setAliasCuenta(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AccountBalanceIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
        <Box mt={3} display="flex" justifyContent="flex-end" gap={1}>
          <Button onClick={handleClose} color="secondary" variant="outlined">
            Cancelar
          </Button>
          <Button onClick={handleSubmit} color="primary" variant="contained">
            Crear Entidad
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ModalCrearEntidad;
